import { StaticApi } from "../api";
import { UrlHandler } from "../pages/UrlHandler";
import { useCategoriesStore } from "../stores/CategoriesStore";
import { useProductStore } from "../stores/ProductStore";
import { useUrlStorage } from "../stores/UrlStore";
import { computeAvailableTags } from "../utilities/computeAvailableTags";
import { initServerSession } from "../utilities/sessionContext";

export async function loader({ params, request }) {
	// Initialize session for data requests during client navigation
	initServerSession(request);

	try {
		const urlInfo = await useUrlStorage.getState().GetUrl(params);
		if (urlInfo?.content_type === "product" && urlInfo?.content_id) {
			let prefetchedProduct = null;
			let footer_content = null;
			try {
				await useProductStore.getState().GetInfo(urlInfo.content_id, true);
				prefetchedProduct = useProductStore.getState().info;
				footer_content =
					prefetchedProduct?.meta?.footer_content?.trim() ||
					prefetchedProduct?.quote?.trim() ||
					prefetchedProduct?.short_description?.trim() ||
					prefetchedProduct?.full_description?.trim() ||
					"A beautiful hand tied bouquet";
			} catch (e) {
				console.warn("SSR prefetch product failed", e);
			}
			return { ...urlInfo, prefetchedProduct, meta: { footer_content } };
		}
		if (urlInfo?.content_type === "category" && urlInfo?.content_id) {
			let prefetchedCategory = null;
			let prefetchedCategoryStructuredData = null;
			let prefetchedProducts = [];
			let footer_content = null;
			try {
				const { category, structuredData } = await useCategoriesStore
					.getState()
					.GetCategory(urlInfo.content_id);
				prefetchedCategory = category;
				prefetchedCategoryStructuredData = structuredData ?? null;
				footer_content = category?.meta?.[urlInfo.content_id]?.footer_content?.trim() || "";

				const productIds = (category?.products_in_category || []).map((p) => p?.products_id).filter(Boolean);
				if (productIds.length) {
					const products = await useProductStore.getState().GetProductInfoBulk(productIds, true);
					const productMap = new Map(products.map((p) => [p.products_id || p.id, p]));
					prefetchedProducts = productIds.map((id) => productMap.get(id)).filter(Boolean);
				}
			} catch (e) {
				console.warn("SSR prefetch category failed", e);
			}
			const prefetchedAvailableTags = computeAvailableTags(prefetchedProducts);
			return {
				...urlInfo,
				prefetchedCategory,
				prefetchedCategoryStructuredData,
				prefetchedProducts,
				prefetchedAvailableTags,
				meta: { footer_content },
			};
		}
		if (urlInfo?.content_type === "static_page" && urlInfo?.content_id) {
			let prefetchedStaticPage = null;
			let footer_content = null;
			try {
				const { page } = await StaticApi.getInfo(urlInfo.content_id);
				prefetchedStaticPage = page;
				footer_content = page?.meta?.[urlInfo.content_id]?.footer_content?.trim() || "";
			} catch (e) {
				console.warn("SSR prefetch static page failed", e);
			}
			return { ...urlInfo, prefetchedStaticPage, meta: { footer_content } };
		}
		return urlInfo;
	} catch (error) {
		return { content_type: "404", content_id: 0, params };
	}
}

export default function UrlHandlerRoute() {
	return <UrlHandler />;
}
